import isOldWebkit from '../helpers/isOldWebkit';
import { removeNonLatin } from '@ott/transforms';

const translateFormatter = function (value, p, cursor, props) {
  const result = props.parse(value);
  if (!result || !value) {
    return {
      value: '',
      cursor: 0,
    };
  }

  const diff = result.length - value.length;
  if (diff > 0) {
    // eslint-disable-next-line no-param-reassign
    cursor += diff;
  }

  return {
    value: result && result.toUpperCase(),
    cursor,
  };
};

export default isOldWebkit ? removeNonLatin : translateFormatter;
